import React, { useEffect, useState, useContext } from "react";

import { AuthContext } from "../context/AuthContext";
import DataTable from 'react-data-table-component';

import { getPaginatedMagazines } from "../controllers/magazineController";
import { useNavigate } from "react-router-dom";

const Magazines = () => {
  // const { user, setUser } = useContext(AuthContext);

  const [state, setState] = useState({
    magazines: [],
    offset: 0,
    perPage: 10,
    page: 1,
    total: 0,
    sortBy: '',
    sortOrder: '',
    q: '',
  });
    const [loading, setLoading] = useState(false);


  const [magazines, setMagazines] = useState([]);
  const navigate = useNavigate();

  const handleSearch = (e) => {
    setState(prev => ({
      ...prev,
      q: e.target.value,
      offset: 0,
      page: 1, // Reset to first page
    }));
  };


  useEffect(() => {
    getPaginatedMagazines(state, setState, setLoading);
  }, [state.offset, state.page, state.perPage, state.sortOrder, state.q]);

  const columns = [
    // {
    //   name: 'ID',
    //   selector: row => row.id,
    //   sortable: true,
    // },
    {
      name: 'S.No',
      cell: (row, index) => state.offset + index + 1,
      width: '80px',
    },
    {
      name: 'Display Name',
      selector: row => row.display_name,
      sortable: true,
    },
    {
      name: 'Google Analytics',
      selector: row => row.ga_code,
      sortable: true,
    },
    {
      name: 'Website',
      selector: row => row.website_url,
    },
    {
      name: 'Cover',
      cell: row => (
        <img
          src={`${row.images}`}
          alt={row.display_name}
          style={{ width: 80 }}
        />
      ),
    },
    {
      name: 'Actions',
      cell: row => (
        <div className="d-flex gap-1">
          <button
            className="btn btn-sm btn-info"
            onClick={() => navigate(`/magazines/${row.id}`)}
          >
            View
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    }
  ];


  // const [loading, setLoading] = useState(true);

  const goToPage = (page) => {
    if (page >= 1 && page <= state.totalPages) {
      setState(prev => ({ ...prev, currentPage: page, page: page }));
    }
  };

  return (
    <div className="container">
      {/* <h1>Magazine Releases</h1> */}
       <input
        type="text"
        placeholder="Search..."
        onChange={handleSearch}
        value={state.q}
        name="q"
      />
      <div className="card">
      <div className="card-body">
      <DataTable
        columns={columns}
        data={state.magazines}
        pagination
        paginationServer
        paginationTotalRows={state.total}
        paginationPerPage={state.perPage}
        onChangePage={(page) => {
          const newOffset = (page - 1) * state.perPage;
          setState(prev => ({ ...prev, offset: newOffset, page: page }));
        }}
        onSort={(column, sortDirection) => {
          setState(prev => ({
            ...prev,
            sortBy: column.selector || column.name,
            sortOrder: sortDirection,
            offset: 0,
            page: 1
          }));
        }}
        progressPending={loading}
        progressComponent={<div className="p-3 text-center">Loading Magazines...</div>}
        noDataComponent={<div className="p-3 text-center">No magazines found</div>}
        sortServer
      />
    </div>
    </div>
    </div>
  );
};

export default Magazines;
